module.exports = new __parcel__URL__("30296_sq.b789ece0.jpg").toString();